<div class="project-list" data-automation-id="project-list-container">
    <res-top-nav-bar></res-top-nav-bar>
    <div class="titleBar" id="titleBar">
        <div>
            <div class="userIcon" data-automation-id="project-list-top-bar-user-button-icon"><i class="fa fa-user"></i>
            </div>
            <div class="loggedUser" data-automation-id="project-list-username-org-label">
                {{username}}</div>
        </div>
        <div>
            <button type="button" data-automation-id="project-list-filter-refresh-button" class="secondary-button"
                (click)="loadData(true)" [disabled]="isRefresh"><i
                    [ngClass]="isRefresh? 'fa fa-spinner fa-spin' : 'fa fa-refresh'"
                    data-automation-id="project-list-refresh-button-icon"></i>{{isRefresh? 'Loading ...' :
                'Reload'}}</button>
            <res-filter [maxChars]=32 [placeholder]='"Filter by Organization, Project, or Description of either ..."'
                [callback]="filterData.bind(this)" data-automation-id="project-list-filter"></res-filter>
        </div>
    </div>
    <div class="grid-container">
        <res-generic-grid [gridName]="gridName" [automationId]="automationId" [pagerVisible]="false" [(isBusy)]="isBusy"
            [(isBusyMessage)]="isBusyMessage" [isBusyOnInit]="true" [columnDefs]="columnDefs" [rowsHaveGrouping]="true"
            [requestInfo]="requestInfo" [contextMenuOptions]="contextMenuOptions" [rowClassRules]="rowClassRules"
            [responseCallback]="responseCallback" [cellClickedCallback]="cellClickedCallback"
            [onCellClicked]="onCellClicked" [cellDoubleClickedCallback]="cellDoubleClickedCallback"
            [loadDataFinishedCallback]="loadDataFinishedCallback" [preferObservable]="true"
            [customErrorHandlingCallback]="errorOnLoadingDataCallback">
        </res-generic-grid>
    </div>
</div>